export const createUpdatePayload = (obj) => {
  const type = Object.keys(obj)[0];
  const payload = obj[Object.keys(obj)[0]];
  return { type, payload };
};

export default (state, action) => {
  switch (action.type) {
    case 'updateHasPush':
      return {
        ...state,
        hasPush: action.payload,
      };
    case 'updateHasEmail':
      return {
        ...state,
        hasEmail: action.payload,
      };    
    case 'updatePushFrequency':
      return {
        ...state,
        pushFrequency: action.payload,
      };
    case 'updateEmailFrequency':
      return {
        ...state,
        emailFrequency: action.payload,
      };
    case 'updateHasNotifications':
      return {
        ...state,
        hasPush: action.payload,
        hasEmail: action.payload,
      };
    case 'updateNotificationsFrequency':
      return {
        ...state,
        pushFrequency: action.payload,
        emailFrequency: action.payload,
      };      
    default:
      return state;
  }
};